export const CATEGORIES = [
  "Fashion", "Beauty", "Food", "Travel", "Technology", "Finance", "Fitness",
  "Education", "Parenting", "Gaming", "Automotive", "Real Estate", "Business",
  "Lifestyle", "Entertainment", "Local Creators",
];

export const PLATFORMS = ["Instagram", "YouTube", "Facebook", "X", "LinkedIn", "Snapchat", "TikTok", "Twitch", "Pinterest"];

export const CONTENT_TYPES = [
  "Reel", "Post", "Story", "Live", "Collaboration", "YouTube Short", "YouTube Video",
  "Product Review", "Integration", "UGC", "Custom",
];

export const CAMPAIGN_TYPES = [
  "Sponsored Content", "UGC", "Product Review", "Local Influencers", "Event Promotion",
  "Affiliate Campaign", "Lead Generation", "Product Launch", "Long-Term Ambassador",
];

export const CREATOR_TIERS = [
  { name: "Nano", min: 1000, max: 10000, label: "Nano (1K–10K)" },
  { name: "Micro", min: 10000, max: 100000, label: "Micro (10K–100K)" },
  { name: "Mid-Tier", min: 100000, max: 500000, label: "Mid-Tier (100K–500K)" },
  { name: "Macro", min: 500000, max: 1000000, label: "Macro (500K–1M)" },
  { name: "Celebrity", min: 1000000, max: null, label: "Celebrity (1M+)" },
];
export const CREATOR_TYPES = CREATOR_TIERS.map((t) => t.name);
export function tierFromFollowers(n) {
  const f = Number(n || 0);
  const t = CREATOR_TIERS.find((x) => f >= x.min && (x.max == null || f < x.max));
  return t ? t.name : "";
}
export function tierLabel(name) {
  const t = CREATOR_TIERS.find((x) => x.name === name);
  return t ? t.label : name;
}

export const AGE_BRACKETS = [
  { label: "Any age", min: null, max: null },
  { label: "18–24", min: 18, max: 24 },
  { label: "25–34", min: 25, max: 34 },
  { label: "35–44", min: 35, max: 44 },
  { label: "45+", min: 45, max: null },
];

// Maps a platform display name to its social_links key
export const PLATFORM_KEYS = {
  Instagram: "instagram", YouTube: "youtube", Facebook: "facebook",
  X: "x", LinkedIn: "linkedin", Snapchat: "snapchat", TikTok: "tiktok", Twitch: "twitch", Pinterest: "pinterest",
};

export const PUBLIC_STATS_PLATFORMS = ["tiktok", "x", "twitch", "pinterest"];

export const LANGUAGES = ["English", "Hindi", "Spanish", "Arabic", "French", "Tamil", "Telugu", "Marathi", "Bengali", "Portuguese"];

export const COUNTRIES = [
  "India", "United Arab Emirates", "Saudi Arabia", "Qatar", "Kuwait", "Oman", "Bahrain", "Egypt", "Turkey", "Jordan",
  "Lebanon", "Iraq", "Iran", "Israel", "United States", "Canada", "Mexico", "Brazil", "United Kingdom", "Germany", "France",
  "Spain", "Italy", "Netherlands", "Ireland", "Portugal", "Poland", "Russia", "Ukraine", "Switzerland", "Sweden",
  "Belgium", "Austria", "Greece", "Australia", "Singapore", "Other",
];

export const ACCOUNT_TYPES = ["Influencer", "UGC Agency", "Performance Marketing Agency"];

export const BUDGET_RANGES = [
  { label: "Any budget", min: null, max: null },
  { label: "Under 10K", min: null, max: 10000 },
  { label: "10K – 25K", min: 10000, max: 25000 },
  { label: "25K – 50K", min: 25000, max: 50000 },
  { label: "50K – 1L", min: 50000, max: 100000 },
  { label: "1L+", min: 100000, max: null },
];

export const CURRENCIES = [
  { code: "INR", symbol: "₹", label: "Indian Rupee (₹)" },
  { code: "USD", symbol: "$", label: "US Dollar ($)" },
  { code: "EUR", symbol: "€", label: "Euro (€)" },
  { code: "GBP", symbol: "£", label: "British Pound (£)" },
  { code: "AED", symbol: "د.إ", label: "UAE Dirham (د.إ)" },
  { code: "SAR", symbol: "﷼", label: "Saudi Riyal (﷼)" },
];

export const CURRENCY_SYMBOLS = CURRENCIES.reduce((acc, c) => ({ ...acc, [c.code]: c.symbol }), {});

export function formatMoney(amount, currency = "USD") {
  const sym = CURRENCY_SYMBOLS[currency] || "";
  const n = Number(amount || 0).toLocaleString(undefined, { maximumFractionDigits: 0 });
  return `${sym}${n}`;
}
